var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckMulti = function SvgCheckMulti(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.846 8.273a1 1 0 1 0-1.48-1.346l-3.106 3.417a1 1 0 0 0 1.48 1.345l3.106-3.416Zm-8.73 5.533a1 1 0 0 0-1.414 1.414l2.485 2.485A1 1 0 0 0 9.6 16.29l-2.485-2.485Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.545 9.057a1 1 0 0 1 .074 1.412l-5.59 6.212a1 1 0 0 1-1.451.038l-2.485-2.485a1 1 0 0 1 1.414-1.414l1.74 1.74 4.885-5.429a1 1 0 0 1 1.413-.074Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11Zm-2 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  })));
};
export default SvgCheckMulti;